import { Injectable } from "@angular/core";

import { GlobalCfgService } from "./globalcfg.service";
import { EventBusService } from "./event-bus.service";
import { environment } from "../environments/environment";
import { HttpClient } from '@angular/common/http';

@Injectable()
export class MiscService {
  constructor(
    private http: HttpClient,
    private globalCfgService: GlobalCfgService,
    private ebService: EventBusService
  ) { }

  getCountries() {
    return this.http.get(
      environment.apiurl +
      "/Countries/?access_token=" +
      this.globalCfgService.getAccessToken(),
      {}
    );
  }

  getStates(countryId) {
    var filter = JSON.stringify({
      where: {
        countryId: countryId
      },
      order: 'name ASC'
    });
    return this.http.get(
      environment.apiurl +
      "/States/?access_token=" +
      this.globalCfgService.getAccessToken() +
      "&filter=" +
      filter
    );
  }

  geocodeQuery(query) {
    return this.http.get('https://nominatim.openstreetmap.org/search.php?q=' + query + '&polygon_geojson=1&format=json');
  }

  getGeoJson(query) {
    //   return this.http.get('https://nominatim.openstreetmap.org/search.php?q=' + query + '&polygon_geojson=1&format=json');
    // return this.http.get('http://localhost:3001/telangana.json');
    var filter = JSON.stringify({
      where: {
        queryTxt: query.toLowerCase()
      }
    });
    return this.http.get(environment.apiurl +
      "/GeoLookups/?access_token=" +
      this.globalCfgService.getAccessToken() +
      "&filter=" +
      filter);
  }

  saveGeoJson(rec) {
    return this.http.post(environment.apiurl +
      "/GeoLookups/?access_token=" +
      this.globalCfgService.getAccessToken(), rec);
  }

  gteTargetCountries() {
    var filter = JSON.stringify({
      order: 'name ASC'
    });
    return this.http.get(environment.apiurl +
      "/TargetCountries/?access_token=" +
      this.globalCfgService.getAccessToken() +
      "&filter=" +
      filter)
  }

  getLabels(gcp) {
    var filter = JSON.stringify({
      where: {
        name: gcp + '_labels'
      }
    });
    return this.http.get(environment.apiurl +
      "/Settings/?access_token=" +
      this.globalCfgService.getAccessToken() +
      "&filter=" +
      filter);
  }

  getACL(gcp) {
    var filter = JSON.stringify({
      where: {
        name: gcp + '_acl'
      }
    });
    return this.http.get(environment.apiurl +
      "/Settings/?access_token=" +
      this.globalCfgService.getAccessToken() +
      "&filter=" +
      filter);
  }

  getSettingByKey(key) {
    var filter = JSON.stringify({
      where: {
        name: key
      }
    });
    return this.http.get(environment.apiurl +
      "/Settings/?access_token=" +
      this.globalCfgService.getAccessToken() +
      "&filter=" +
      filter);
  }

  getBranding(key) {
    var filter = JSON.stringify({
      where: {
        gcp: key
      }
    });
    return this.http.get(environment.apiurl +
      "/Brandings" +
      "?filter=" +
      filter);
  }

  getAssets(gcp, type) {
    var filter = JSON.stringify({
      where: {
        gcp: gcp,
        type: type
      },
      order: 'createdon DESC'
    });
    return this.http.get(environment.apiurl +
      "/Assets?access_token=" +
      this.globalCfgService.getAccessToken() +
      "&filter=" +
      filter);
  }

  addAsset(rec) {
    return this.http.post(environment.apiurl +
      "/Assets/?access_token=" +
      this.globalCfgService.getAccessToken(), rec);
  }

  updateAsset(rec) {
    return this.http.patch(environment.apiurl +
      "/Assets/?access_token=" +
      this.globalCfgService.getAccessToken(), rec);
  }

  getAssetsStat(gcp) {
    return this.http.post(environment.apiurl +
      "/Assets/stats?access_token=" +
      this.globalCfgService.getAccessToken(), { gcp: gcp });
  }

  getLinkTypes() {
    var filter = JSON.stringify({
      order: 'seq ASC'
    });
    return this.http.get(environment.apiurl +
      "/LinkTypes?access_token=" +
      this.globalCfgService.getAccessToken() +
      "&filter=" +
      filter);
  }

  getPackagesList(gcp, packageLevel) {
    var rec = {};
    rec["gcp"] = gcp;
    rec["packageLevel"] = packageLevel;
    return this.http.post(environment.apiurl +
      "/Packages/list?access_token=" +
      this.globalCfgService.getAccessToken(), rec);
  }

  getDevices(gcp) {
    var filter = JSON.stringify({
      include: ["links"]
    });
    return this.http.get(environment.apiurl +
      "/Devices/fullList" + "?filter=" + filter + "&gcp=" + gcp + "&access_token=" +
      this.globalCfgService.getAccessToken());
  }

  addDevice(rec) {
    return this.http.post(environment.apiurl +
      "/Devices/?access_token=" +
      this.globalCfgService.getAccessToken(), rec);
  }

  updateDevice(rec) {
    return this.http.patch(environment.apiurl +
      "/Devices/" + rec.id + "?access_token=" +
      this.globalCfgService.getAccessToken(), rec);
  }

  linkDevice(id, rec) {
    return this.http.post(environment.apiurl +
      "/Devices/link/" + id + "?access_token=" +
      this.globalCfgService.getAccessToken(), rec);
  }

  getOrganisations() {
    var filter = JSON.stringify({
      include: ['contact'],
      order: 'legalName ASC'
    });
    return this.http.get(environment.apiurl +
      "/Organisations?access_token=" +
      this.globalCfgService.getAccessToken() +
      "&filter=" +
      filter);
  }

  addOrganisation(rec) {
    return this.http.post(environment.apiurl +
      "/Organisations?access_token=" +
      this.globalCfgService.getAccessToken(), rec);
  }

  updateOrganisation(rec) {
    return this.http.patch(environment.apiurl +
      "/Organisations/" + rec.id + "?access_token=" +
      this.globalCfgService.getAccessToken(), rec);
  }

  getActiveTrackingList(gcp) {
    return this.http.post(environment.apiurl +
      "/Devices/activeTrackingList?access_token=" +
      this.globalCfgService.getAccessToken(), {gcp: gcp});
  }

  getHistory(id, linkType, current?) {
    if (current) {
      var filter = JSON.stringify({
        where: {
          linkedWithType: linkType,
          isCurrentLink : true
        },
        include: ["linkedHistory"]
      });
    } else {
      var filter = JSON.stringify({
        where: {
          linkedWithType: linkType,
          isCurrentLink : false
        },
        include: ["linkedHistory"]
      });
    }
    
    return this.http.get(environment.apiurl +
      "/Devices/trackHistory/" + id + "?filter=" + filter + "&access_token=" +
      this.globalCfgService.getAccessToken());
  }

  // ownership chain related endpoints
  addChain(rec) {
    return this.http.post(environment.apiurl +
      "/Chains?access_token=" +
      this.globalCfgService.getAccessToken(), rec);
  }

  deleteChain(id) {
    return this.http.delete(environment.apiurl + "/Chains/" + id + "?access_token=" + this.globalCfgService.getAccessToken());
  }

  updateChain(rec) {
    return this.http.patch(environment.apiurl + "/Chains/" + rec.id + "?access_token=" + this.globalCfgService.getAccessToken(), rec);
  }

  addParticipantToChain(rec) {
    return this.http.post(environment.apiurl +
      "/Participants/?access_token=" +
      this.globalCfgService.getAccessToken(), rec);
  }

  updateParticipantInChain(rec) {
    return this.http.post(environment.apiurl +
      "/Participants/edit?access_token=" +
      this.globalCfgService.getAccessToken(), rec);
  }

  removeParticipantFromChain(id) {
    return this.http.delete(environment.apiurl +
      "/Participants/" + id + "?access_token=" +
      this.globalCfgService.getAccessToken());
  }

  getChains(gcp) {
    return this.http.get(environment.apiurl +
      "/Chains?access_token=" +
      this.globalCfgService.getAccessToken() + "&filter=" + JSON.stringify({
        where: {
          gcp: gcp
        },
        include: {
          relation: "participants",
          scope: {
            "order": "seq ASC",
            include: ["role"]
          }
        }
      }
      ));
  }
  
  getGeoFenceLiveTracking(packid) {
    return this.http.get(environment.apiurl +
     "/GeoFences/getFenceByPackageId?packageId="+packid
      +
      "&access_token=" +
        this.globalCfgService.getAccessToken()
    )
  }

  getIncidentsShowHideFencesdata(values){
    return this.http.get(environment.apiurl +
      "/GeoFences?"+"filter="  + JSON.stringify({
        where: {
          gcp:values

        }
      }
      )+
      "&access_token=" +
        this.globalCfgService.getAccessToken()
    )
  }

  // fences of Batches based on device linked to package
  getShowAllGeoFenceLiveTrackingFences(packageIdsObj) {
    return this.http.get(environment.apiurl +
      "/GeoFences/getFencesByPackageIds?"+"packageIdsObj="+ packageIdsObj 
       +
       "&access_token=" +
         this.globalCfgService.getAccessToken()
     )
  }
}